// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3MOjO","title":"FrontImage_title__2-C6-"};